/**
 * 按 novel_id 取单个 per-locale 书行详情（`GET /api/v1/books/:id/language`）。
 *
 * 选书组件与各处「已选书」回显都要这份数据，此前每个调用方各写一份同样的 useQuery。
 * 收进一个 hook，queryKey 与 enabled 口径只有一处定义。
 */

import type { NovelResponse } from '@novel-admin/shared';
import { useQuery } from '@tanstack/react-query';
import { booksApi } from '~/hooks/use-books';

export function useBookLanguageRow(
  novelId: string | null | undefined,
  /** 额外的启用条件；本 hook 已经处理了「id 为空就不查」，这里只传业务侧的收窄（如编辑态不查） */
  options?: { enabled?: boolean },
) {
  const id = novelId ?? '';
  return useQuery<NovelResponse>({
    queryKey: ['books', 'language', id],
    enabled: !!id && (options?.enabled ?? true),
    queryFn: () => booksApi.language(id),
  });
}
